// @flow

import { useState } from 'react';

import Loader from 'client/components/loader';

const useLoader = (defaultState: boolean = false) => {
  const [isLoading, setLoading] = useState(defaultState);
  return {
    isLoading,
    setLoading,
    Loader,
  };
};

export default useLoader;
